
import React from 'react';

const ResidentialContactDetails: React.FC = () => {
  return (
    <div className="bg-itmgmt-light-blue rounded-lg shadow-md p-6 border border-gray-100">
      <h3 className="heading-md text-itmgmt-dark-blue mb-6">Residential Support</h3>
      
      <div className="space-y-6">
        <div>
          <h4 className="text-base font-semibold text-itmgmt-dark-blue mb-2">Home IT Support</h4>
          <p className="text-gray-600 mb-2">
            We provide friendly and professional IT support for homeowners.
            From setting up your home network to troubleshooting computer issues, 
            our team is here to help.
          </p>
        </div>
        
        <div>
          <h4 className="text-base font-semibold text-itmgmt-dark-blue mb-2">Support Hours</h4>
          <div className="text-gray-600 space-y-1">
            <p>8:00 AM - 6:00 PM 7 days a week</p>
          </div>
        </div>
        
        <div>
          <h4 className="text-base font-semibold text-itmgmt-dark-blue mb-2">Contact Information</h4>
          <div className="text-gray-600 space-y-1">
            <p>
              <span className="font-medium">Phone:</span> +1-877-748-6468
            </p>
            <p>
              <span className="font-medium">Email:</span> info@itmgmtsol.com
            </p>
          </div>
        </div>
        
        <div>
          <h4 className="text-base font-semibold text-itmgmt-dark-blue mb-2">Service Area</h4>
          <p className="text-gray-600">
            We provide residential IT services in the Airmont, NY area and surrounding regions.
            Enter your zip code in the form to check if we service your location.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResidentialContactDetails;
